import React, { useEffect, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { INPUT_TYPE } from './../../models/form'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import './form.scss'
import { PropsType } from '../../models/util'
import LuxIcon from '../icons/LuxIcon'
import { addLocale } from 'primereact/api'
import { LUX_INPUT_TYPE } from '../../Techedge-Wardrobe'
import CheckboxInput from './CheckboxInput'

interface FormInputProps extends PropsType {
    type: LUX_INPUT_TYPE
    onChangeCallback: (e: any) => void
    name?: string
    icon?: string
    iconPos?: string
    dates?: { start: Date; end: Date }
    optionsList?: any[]
    value: string | string[]
    placeholder?: string
    datesPlaceholders?: { from: string; to: string }
    classes?: string
    index?: number
    disabled?: boolean
    additionalProps?: any
    colWidth?: number | string
    filterable?: boolean
    activeFilters?: any
    containerClasses?: string
    clearable?: boolean
    floatingLabel?: boolean
    fixedLabel?: boolean
    label?: string
    minDate?: Date
    maxDate?: Date
    maxStartDate?: Date
    minEndDate?: Date
    firstDayOfWeek?: number
    selectAllLabel?: boolean
    onRemoveChip?: (e: any) => void
    onClearDate?: (e: any) => void
}

// DEPRECATED

const FormInput = (props: FormInputProps) => {
    const {
        type,
        onChangeCallback,
        name,
        optionsList,
        value,
        placeholder,
        classes,
        index,
        colWidth,
        disabled,
        additionalProps,
        dates,
        containerClasses,
        style,
        icon,
        iconPos,
        clearable,
        floatingLabel,
        fixedLabel,
        label,
        minDate,
        maxDate,
        maxStartDate,
        minEndDate,
        firstDayOfWeek,
        selectAllLabel,
        onRemoveChip,
        onClearDate,
    } = props

    let today = new Date()
    let year = today.getFullYear()

    const validateInput = () => {
        if (type === 'number') {
            return value !== undefined && value !== null && value !== ''
        } else {
            return value && value.length > 0
        }
    }

    const selectComponent = () => {
        return (
            <div
                className={`wardrobe-form-input p-col-${
                    colWidth ? colWidth : '3'
                } ${containerClasses ? containerClasses : ''}
                 ${floatingLabel || fixedLabel ? 'floating-label' : ''}`}>
                <Dropdown
                    dropdownIcon="cu cu-caret-down"
                    value={props.value}
                    options={optionsList}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={(e: any) => {
                        if (e.originalEvent.type === 'keydown') return
                        onChangeCallback(e)
                    }}
                    filter={props.filterable}
                    className="w-100"
                    showClear={clearable}
                    panelClassName="wardrobe-form-panel"
                    {...additionalProps}
                />
                {(floatingLabel || fixedLabel) && (
                    <label
                        className={`${
                            (floatingLabel && value) || fixedLabel
                                ? 'active'
                                : ''
                        }`}>
                        {label ? label : placeholder}
                    </label>
                )}
            </div>
        )
    }

    const inputComponent = (type: string) => {
        return (
            <div
                className={`wardrobe-form-input p-col-${
                    colWidth ? colWidth : '3'
                } ${containerClasses ? containerClasses : ''} ${
                    icon && icon !== ''
                        ? `${
                              'p-input-icon-' +
                              (iconPos && iconPos === 'right'
                                  ? 'right'
                                  : 'left')
                          }`
                        : ''
                } ${floatingLabel || fixedLabel ? 'floating-label' : ''}`}>
                <InputText
                    icon={icon}
                    key={`text${index}`}
                    name={name}
                    value={value}
                    disabled={disabled}
                    onChange={(e) => onChangeCallback(e.target.value)}
                    placeholder={placeholder ? String(placeholder) : ''}
                    type={type}
                    keyfilter={type === 'number' ? /^[^e+-,.E]+$/ : ''}
                    className={`w-100 ${classes ? classes : ''}`}
                    {...additionalProps}
                />
                {icon && <LuxIcon icon={icon} />}
                {(floatingLabel || fixedLabel) && (
                    <label
                        className={`${
                            (floatingLabel && validateInput()) || fixedLabel
                                ? 'active'
                                : ''
                        }`}>
                        {label ? label : placeholder}
                    </label>
                )}
            </div>
        )
    }

    const textareaComponent = () => {
        return (
            <div
                className={`wardrobe-form-input p-col-${
                    colWidth ? colWidth : '3'
                } ${containerClasses ? containerClasses : ''}
                ${floatingLabel || fixedLabel ? 'floating-label' : ''}`}>
                <InputTextarea
                    key={`textarea${index}`}
                    name={name}
                    value={value}
                    disabled={disabled}
                    rows={5}
                    cols={10}
                    onChange={(e) => onChangeCallback(e.target.value)}
                    placeholder={String(placeholder)}
                    className={`${classes} w-100`}
                    // autoResize
                />
                {(floatingLabel || fixedLabel) && (
                    <label
                        className={`${
                            (floatingLabel && value && value.length > 0) ||
                            fixedLabel
                                ? 'active'
                                : ''
                        }`}>
                        {label ? label : placeholder}
                    </label>
                )}
            </div>
        )
    }

    const datePickerComponent = () => {
        addLocale('custom', {
            firstDayOfWeek: firstDayOfWeek ? firstDayOfWeek : 0,
        })
        return (
            <div
                className={`wardrobe-form-input p-col-${
                    colWidth ? colWidth : '3'
                } ${containerClasses ? containerClasses : ''}`}>
                <Calendar
                    panelClassName="wardrobe-datepicker"
                    locale="custom"
                    monthNavigator
                    yearNavigator
                    yearRange={`1970:${year + 5}`}
                    baseZIndex={2000}
                    showButtonBar
                    inputStyle={style ? style : {}}
                    showIcon
                    className="w-100 wardrobe-calendar"
                    disabled={disabled}
                    value={value}
                    dateFormat="yy/mm/dd"
                    selectionMode="single"
                    placeholder={
                        props.placeholder ? props.placeholder : 'Select a Date'
                    }
                    appendTo={document.body}
                    onChange={(e) => onChangeCallback(e.value)}
                    {...additionalProps}
                    minDate={minDate}
                    maxDate={maxDate}
                    icon="cu cu-calendar"
                    onClearButtonClick={onClearDate}
                />
            </div>
        )
    }

    const dateRangeComponent = () => {
        addLocale('custom', {
            firstDayOfWeek: firstDayOfWeek ? firstDayOfWeek : 0,
        })
        let _minEndDate = dates?.start

        if (minEndDate) {
            _minEndDate = dates?.start > minEndDate ? dates?.start : minEndDate
        }
        return (
            <>
                <div
                    className={`wardrobe-form-input p-col-${
                        colWidth ? colWidth : '3'
                    } ${containerClasses ? containerClasses : ''} ${
                        floatingLabel || fixedLabel ? 'floating-label' : ''
                    } `}>
                    <Calendar
                        panelClassName="wardrobe-datepicker"
                        locale="custom"
                        icon="cu cu-calendar"
                        monthNavigator
                        yearNavigator
                        yearRange={`1970:${year + 5}`}
                        baseZIndex={2000}
                        showButtonBar
                        showIcon
                        className={`wardrobe-calendar ${
                            props.additionalProps?.inputWidth
                                ? props.additionalProps?.inputWidth
                                : 'w-100'
                        }`}
                        value={dates?.start}
                        disabled={disabled}
                        dateFormat="yy/mm/dd"
                        selectionMode="single"
                        placeholder={
                            props.additionalProps?.datesPlaceholders?.from
                                ? props.additionalProps.datesPlaceholders.from
                                : 'Select Start Date'
                        }
                        appendTo={document.body}
                        minDate={minDate}
                        maxDate={maxStartDate || maxDate}
                        onChange={(e) => onChangeCallback([e.value, undefined])}
                        {...additionalProps}
                    />
                    {(floatingLabel || fixedLabel) && (
                        <label
                            className={`${
                                (floatingLabel && value) || fixedLabel
                                    ? 'active'
                                    : ''
                            }`}>
                            {`${label ? label : placeholder} Start`}
                        </label>
                    )}
                </div>
                <div
                    className={`wardrobe-form-input p-col-${
                        colWidth ? colWidth : '3'
                    } ${containerClasses ? containerClasses : ''} ${
                        floatingLabel || fixedLabel ? 'floating-label' : ''
                    }`}>
                    <Calendar
                        panelClassName="wardrobe-datepicker"
                        locale="custom"
                        icon="cu cu-calendar"
                        monthNavigator
                        yearNavigator
                        yearRange={`1970:${year + 5}`}
                        baseZIndex={2000}
                        showButtonBar
                        showIcon
                        value={dates?.end}
                        disabled={!dates?.start || disabled}
                        className={`wardrobe-calendar ${
                            props.additionalProps?.inputWidth
                                ? props.additionalProps?.inputWidth
                                : 'w-100'
                        }`}
                        appendTo={document.body}
                        dateFormat="yy/mm/dd"
                        selectionMode="single"
                        placeholder={
                            props.additionalProps?.datesPlaceholders?.to
                                ? props.additionalProps.datesPlaceholders.to
                                : 'Select End Date'
                        }
                        minDate={_minEndDate}
                        maxDate={maxDate}
                        onChange={(e) =>
                            onChangeCallback([dates?.start, e.value])
                        }
                        {...additionalProps}
                    />
                    {(floatingLabel || fixedLabel) && (
                        <label
                            className={`${
                                (floatingLabel && value) || fixedLabel
                                    ? 'active'
                                    : ''
                            }`}>
                            {`${label ? label : placeholder} End`}
                        </label>
                    )}
                </div>
            </>
        )
    }

    const getSelectedItemTemplate = (
        value: any,
        optionLabel?: string,
        optionValue?: string
    ) => {
        // console.log('SELECTED ITEM TEMPALTE', optionLabel, optionValue)
        if (optionLabel && optionValue) {
            let find = optionsList.find(
                (item: any) =>
                    (optionValue ? item[optionValue] : item) === value
            )
            if (find) {
                return find[optionLabel]
            }
        } else if (optionLabel && value[optionLabel]) {
            return value[optionLabel]
        }
        console.log('MULTISELECT SELECTED ITEM TEMPLATE', value)
        return value
    }

    const multiSelectComponent = () => {
        const [checked, setChecked] = useState(false)

        useEffect(() => {
            if (value?.length === optionsList?.length) {
                setChecked(true)
            } else {
                setChecked(false)
            }
        }, [value, optionsList])

        const panelHeaderTemplate = (opt) => {
            return (
                <div className="p-multiselect-header p-d-flex p-flex-wrap-reverse">
                    <CheckboxInput
                        value={checked}
                        onChangeCallback={(val) => {
                            opt.onChange()
                            setChecked(val.target.checked)
                        }}
                        label={
                            additionalProps.selectAllLabelText
                                ? additionalProps.selectAllLabelText
                                : 'Select All'
                        }
                    />
                    {props.filterable && opt.filterElement}
                </div>
            )
        }

        return (
            <div
                className={`wardrobe-form-input p-col-${
                    colWidth ? colWidth : '3'
                } ${containerClasses ? containerClasses : ''} 
                ${floatingLabel || fixedLabel ? 'floating-label' : ''}`}>
                <MultiSelect
                    key={`wardrobe-form-input-${props?.name}`}
                    dropdownIcon="cu cu-caret-down"
                    name={name}
                    placeholder={placeholder}
                    panelClassName="wardrobe-form-panel"
                    options={optionsList || []}
                    disabled={disabled}
                    className={`${classes} w-100`}
                    onChange={(e: any) => {
                        console.log('MULTISELECT', e, props)
                        onChangeCallback(e)
                    }}
                    {...(additionalProps?.optionLabel
                        ? { optionLabel: additionalProps.optionLabel }
                        : {})}
                    {...(additionalProps?.optionValue
                        ? { optionValue: additionalProps.optionValue }
                        : {})}
                    {...(additionalProps?.optionGroupLabel
                        ? { optionGroupLabel: additionalProps.optionGroupLabel }
                        : {})}
                    {...(additionalProps?.optionGroupChildren
                        ? {
                              optionGroupChildren:
                                  additionalProps.optionGroupChildren,
                          }
                        : {})}
                    value={value}
                    display="chip"
                    filter={props.filterable}
                    showClear={clearable}
                    showSelectAll={selectAllLabel ? false : true}
                    panelHeaderTemplate={
                        additionalProps.panelHeaderTemplate
                            ? panelHeaderTemplate
                            : null
                    }
                    {...(selectAllLabel && {
                        selectedItemsLabel: `${
                            value && value.length - 1 === optionsList.length
                                ? 'All'
                                : value
                                ? value.length
                                : 0
                        } items selected`,
                        selectedItemTemplate: (value) => {
                            if (selectAllLabel) {
                                return value !== -1 && value ? (
                                    <div className="p-multiselect-token">
                                        <span className="p-multiselect-token-label">
                                            {getSelectedItemTemplate(
                                                value,
                                                additionalProps?.optionLabel,
                                                additionalProps?.optionValue
                                            )}
                                        </span>
                                        <span
                                            className="p-multiselect-token-icon pi pi-times-circle"
                                            onClick={() =>
                                                onRemoveChip(value)
                                            }></span>
                                    </div>
                                ) : null
                            }
                        },
                    })}
                />
                {(floatingLabel || fixedLabel) && (
                    <label
                        className={`${
                            (floatingLabel &&
                                value &&
                                (!Array.isArray(value) || value.length)) ||
                            fixedLabel
                                ? 'active'
                                : ''
                        }`}>
                        {label ? label : placeholder}
                    </label>
                )}
            </div>
        )
    }

    switch (type) {
        case INPUT_TYPE.select:
            return selectComponent()
        case INPUT_TYPE.text:
            return inputComponent('text')
        case INPUT_TYPE.textarea:
            return textareaComponent()
        case INPUT_TYPE.number:
            return inputComponent('number')
        case INPUT_TYPE.date:
            return datePickerComponent()
        case INPUT_TYPE.daterange:
            return dateRangeComponent()
        case INPUT_TYPE.multiselect:
            return multiSelectComponent()
        default:
            return inputComponent('text')
    }
}

export default FormInput
